import { LangE } from './../../models/enums';
import {StylesConfig} from "react-select";

// custom styling of the select category dropdown list for the search component
export const customSearchCategorySelectStyles = (lang: LangE): StylesConfig<any, false> => ({
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#333333' : '#ffffff',
        color: state.isSelected ? '#ffffff !important' : '#000000',
        // maxWidth: 250,
        whiteSpace: 'nowrap',
        fontSize: '0.87rem',
        lineHeight: '1.31rem',
        height: 29,
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        '&:hover': {
            color: '#34A7F0'
        },
    }),
    control: (provided, state) => ({
        ...provided,
        height: 41,
        /**
         * The control is sized by its content inside a flex row, and react-select's valueContainer
         * carries `overflow: hidden` — so with nothing selected it collapses to roughly the
         * placeholder's own width and clips it. That did not show while the placeholder was
         * react-select's short built-in "Select..."; `Search in...` / `חפש ב...` need the room.
         * 150px also covers the widest SELECTED label that fits on one line ("Delivery number"),
         * and stays under the natural width of the long options ("Post/sound production"), so no
         * layout that already fits moves.
         */
        minWidth: 150,
        textAlign: 'center',
        background: '#34A7F0',
        borderRadius: 0,
        borderEndStartRadius: 25,
        borderStartStartRadius: 25,
        border: '1px solid #E4E6E7',
        boxShadow: 'none',
        cursor: 'pointer',
        "&:hover": {
            borderColor: '#E4E6E7',
            outline: 'none',
            boxShadow: 'none',
            backgroundColor: '#248ACB',
        },
        "&:active": {
            borderColor: '#E4E6E7',
            outline: 'none',
            boxShadow: 'none'
        },
        "&:focus": {
            borderColor: '#E4E6E7',
            outline: 'none',
            boxShadow: 'none'
        }
    }),
    indicatorSeparator: () => ({}),
    placeholder: (provided) => ({
        ...provided,
        color: '#fff',
        fontFamily: lang === LangE.EN ? 'Roboto' : 'Rubik',
        fontSize: '.87rem',
        lineHeight: '1.31rem',
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: 0,
        paddingInlineStart: 20,
        fontFamily: lang === LangE.EN ? 'Roboto' : 'Rubik',
        fontSize: '.87rem',
        lineHeight: '1.31rem',
        overflow: 'none',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#fff',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        padding: 8,
        paddingInlineEnd: 13,
    }),
    menu: (provided) => ({
        ...provided,
        width: 'fit-content',
        boxShadow: '0px 4px 9px rgba(116, 116, 116, 0.25)',
        borderRadius: 5,
    }),
    menuList: (provided) => ({
        ...provided,
        minHeight: 415,
        overflow: 'hidden'
    })
});